import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import cx from 'classnames';
import i18n from 'i18next';
import ModalDialog from '../ui/modal-dialog';
var t = i18n.getFixedT(null, 'event-management');
var gt = i18n.getFixedT(null, 'app');
var EventDetialDialog = /*#__PURE__*/React.memo(function (props) {
  var onClose = props.onClose,
      data = props.data,
      id = props.id;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-event-detial'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-event-type'), ":"), " ", data.type), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-description'), ":"), " ", data.description), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-location'), ":"), " ", data.location), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-info-source'), ":"), " ", data.source), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-received-time'), ":"), " ", data.createdAt), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-start-time'), ":"), " ", data.beginTime), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("span", null, t('lbl-end-time'), ":"), " ", data.endTime)));
});
EventDetialDialog.defaultProps = {
  id: 'g-event-detial-dialog'
};
EventDetialDialog.propTypes = {
  id: PropTypes.string
};
export default EventDetialDialog;